// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PDebounce = require("p-debounce").default;

function make(waitOpt, fn) {
  let wait = waitOpt !== undefined ? waitOpt : 200;
  return PDebounce(fn, wait, {
    leading: false
  });
}

exports.make = make;
/* p-debounce Not a pure module */
